import { createFileRoute } from '@tanstack/react-router'
import { LearnHubshiftPage } from '@/features/learn-hubshift/learn-hubshift-page'

// Under `_organization` like every other sidebar destination (my-goals,
// my-consent, ...), so the page keeps the app shell — sidebar, header and a way
// back. The content itself is not org-scoped, but a nav item that drops the
// chrome when clicked is a dead end, which is what putting this beside
// `get-the-app` produced. `get-the-app` sits outside on purpose: it is a
// full-screen post-login interstitial, not a content page.
export const Route = createFileRoute('/_authenticated/_organization/learn-hubshift/')({
  component: LearnHubshiftPage,
})
